export default [
    {
      path: '/sales',
      name: 'sales',
      component: () => import('@/views/sft/Sales.vue'),
      meta: {
        preventHorizontalScroll: true
      }
    }
  ]